export * from './lib/info-banner-data-access.module';
